import React from 'react';
import { ThemeSuspense } from 'components';
import useSettings from 'hooks/useSettings';
import { MatxLayouts } from './index';


const Layout = (props) => {
  const { settings } = useSettings();
  const Layout = MatxLayouts[settings.activeLayout];

  return (
    <ThemeSuspense>
      <Layout {...props} />
    </ThemeSuspense>
  );
};

export default Layout;
